import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/primeng';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow } from '../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { StoreCampaignService } from '../../../services/store/stores-campaign.service';
import { RevenueAnalysisTreeComponent } from './tree/revenue-analysis-tree.component';
import { RevenueAnalysisTrendComponent } from './trend/revenue-analysis-trend.component';

@Component({
    selector: 'app-revenue-analysis',
    templateUrl: './revenue-analysis.component.html'

})
export class RevenueAnalysisComponent implements OnInit {
    @ViewChild(RevenueAnalysisTreeComponent) tree: RevenueAnalysisTreeComponent;
    @ViewChild(RevenueAnalysisTrendComponent) trend: RevenueAnalysisTrendComponent;
    types: MenuItem[];
    activeIndex: number;
    oldData: any;
    searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

    constructor(private tSvc: TranslateService,
                private svcAnalytics: AnalyticsService,
                public svcStore: StoreCampaignService,
                private searchModelFactory: SearchToolbarModelFactoryService) {
    }

    ngOnInit() {
        const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
        searchParams.svcAnalytics = this.svcAnalytics;
        searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
        searchParams.finestra = SearchToolbarFilterWindow.Three;
        searchParams.raggruppamento = SearchToolbarFilterGrouping.All;

        this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
            this.searchModel = model;
        });
        this.types = [];
        this.activeIndex = 0;
        this.tSvc.get([
            'customers.revenue_analysis_tree',
            'customers.revenue_analysis_trends',
        ]).subscribe(res => {
            this.types.push(
                {
                    label: res['customers.revenue_analysis_tree'],
                    command: (event: any) => {
                        this.activeIndex = 0;
                    }
                },
                {
                    label: res['customers.revenue_analysis_trends'],
                    command: (event: any) => {
                        this.activeIndex = 1;
                    }
                })
        });
        this.svcStore.getCategories().subscribe();
    }

    ApplyResult (data) {
        const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

        switch (this.activeIndex) {
            case 0:
                if (!isDataEquals) {
                    this.trend.resetData();
                }
                this.tree.searchValue(data);
                break;
            case 1:
                if (!isDataEquals) {
                    this.tree.resetData();
                }
                this.trend.searchValue(data);
                break;
        }

        this.oldData = { ...data };
    }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/revenue-analysis/revenue-analysis.component.ts